<script setup lang="ts">
/**
 * 默认事件属性编辑器。
 * 以多行文本直接编辑 Parameter 数组，用于无 schema 且无专用编辑器的兜底展示。
 */
import EventPropRow from '@/components/eventEditors/EventPropRow.vue'
import type EventBase from '@/model/EventClass/EventBase'

defineProps<{
  /** 当前编辑的事件实例 */
  event: EventBase
}>()
</script>

<template>
  <div class="event-edit event-prop-form">
    <EventPropRow label="Parameter" align-start value-stack>
      <textarea
        class="param-textarea"
        :value="(event.Parameter || []).join('\n')"
        rows="12"
        @input="event.Parameter = ($event.target as HTMLTextAreaElement).value.split('\n')"
      />
    </EventPropRow>
  </div>
</template>

<style scoped>
.param-textarea {
  width: 100%;
  min-height: 120px;
  color: var(--theme-text-heading);
  background: var(--theme-bg-surface);
  border: 1px solid var(--theme-border);
  font-family: ui-monospace, monospace;
  font-size: 12px;
  padding: 8px 10px;
  resize: vertical;
  box-sizing: border-box;
}

.param-textarea:focus {
  outline: none;
  border-color: var(--theme-accent);
}
</style>
